import { Link } from 'react-router-dom'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'

import { useOrgPerm } from '@/hooks/useOrgPerm'
import { TEAM_MEMBER_FIELDS } from '@/shared/constants'
import { WrapperProps } from '@/shared/routes'
import Layout, { LayoutLoading } from '@/components/Layout'
import { PageUnauthorized } from '@/components/PageUnauthorized'
import { TeamMemberTable } from '@/components/TeamMemberTable'

import AddTeamMemberModal from './components/AddTeamMemberModal'
import useDetailTeamMember from './hooks/useDetailTeamMember'

function OrgDetailTeamMember({ title }: WrapperProps) {
  const {
    team,
    isLoading,
    teamPath,
    search,
    setSearch,
    currentOrg,
    canAddTeamMember,
    canEditTeam,
    resetParams,
    teamMembers,
    handleUpdateRole,
    handleRemoveMember,
    // Inline editing
    isEditing,
    editedName,
    inputRef,
    setEditedName,
    handleDoubleClick,
    handleSave,
    handleKeyDown,
  } = useDetailTeamMember()

  return isLoading ? (
    <LayoutLoading title='Loading...' />
  ) : team && !isLoading ? (
    <Layout
      title={
        <div className='flex-c'>
          <Link className='text-light font-normal' title={title} to={teamPath}>
            {title}
          </Link>
          <div>/</div>
          {isEditing ? (
            <input
              ref={inputRef}
              type='text'
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              onBlur={handleSave}
              onKeyDown={handleKeyDown}
              className='px-2 py-1 border-b border-gray-300 outline-none'
              style={{ minWidth: '200px' }}
            />
          ) : (
            <div
              onDoubleClick={handleDoubleClick}
              style={{ cursor: canEditTeam ? 'text' : 'default' }}
              title={canEditTeam ? 'Double-click to edit' : ''}
            >
              {team.name}
            </div>
          )}
        </div>
      }
      search={search}
      onSearch={setSearch}
      onClearSearch={resetParams}
      actions={
        //Validate if currentOrg exist and canAddTeamMember is true
        currentOrg && canAddTeamMember ? (
          //Render Add Team Member Modal
          <AddTeamMemberModal team={team} />
        ) : undefined
      }
    >
      <div className='mb-8'>
        {/* Render Team Member Table */}
        <TeamMemberTable
          fields={TEAM_MEMBER_FIELDS}
          team={team}
          isLoading={isLoading}
          members={teamMembers}
          onUpdateRole={handleUpdateRole}
          onRemove={handleRemoveMember}
        />
      </div>
    </Layout>
  ) : null
}

export default function OrgDetailTeamDetail({ title }: WrapperProps) {
  const canViewTeamDetail = useOrgPerm(OrgPermission.TeamsViewIndividualTeam)

  return !canViewTeamDetail ? (
    <Layout title={title}>
      <PageUnauthorized />
    </Layout>
  ) : (
    <OrgDetailTeamMember title={title} />
  )
}
